import { render } from "./PaymentInstructions.vue?vue&type=template&id=2e29619f&ts=true"
import script from "./PaymentInstructions.vue?vue&type=script&lang=ts"
export * from "./PaymentInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__